import { Label, Spinner, InputError } from '@schibsted-svp/react-ui';
import { HistoryListItem } from './HistoryListItem';
import type { CategoryHistoryData } from './types';
import css from './HistoryList.module.scss';

type HistoryListProps = {
    data: CategoryHistoryData[];
    isLoading: boolean;
    isError: boolean;
    openPreview: (data: CategoryHistoryData) => void;
};

export function HistoryList({ data, isLoading, isError, openPreview }: HistoryListProps) {
    if (isLoading) {
        return <Spinner containerClassName={css.spinner} size="small" />;
    }

    if (isError) {
        return <InputError className={css.error}>History fetching error</InputError>;
    }

    if (!data || !data.length) {
        return <div className={css.empty}>No history entries found</div>;
    }

    return (
        <ul className={css.list}>
            <li className={css.header}>
                <Label>Date</Label>
                <Label>History</Label>
            </li>
            {data.map((itemData) => (
                <HistoryListItem data={itemData} key={`history:item:${itemData.id}`} openPreview={openPreview} />
            ))}
        </ul>
    );
}
